import React from 'react';
import PropTypes from 'prop-types';

const NavigationItemImage = ({ url }) => {
  if (!url) {
    return null;
  }

  return (
    <span className="nav__image" style={{ backgroundImage: `url(${url})` }} />
  );
};

NavigationItemImage.propTypes = {
  url: PropTypes.string,
};

export default React.memo(NavigationItemImage);
